// extracted by mini-css-extract-plugin
export var label = "_ig-0";
export var treatmentCard = "_ig-1";